const getVisibleVehiclesByAccountIDUsecase = (repository) => async (id) => {
    return await repository(id);
}

export default getVisibleVehiclesByAccountIDUsecase;